import { Actions as PAYROLL_ACTIONS } from "@/redux/actions/payrollActions";
import { CheckBadgeIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import { ArrowTopRightOnSquareIcon } from "@/icons/outline";
import ProgressBar from "@/components/common/ProgressBar";
import { camelCase, merge } from "lodash";
import { useMemo, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

const PayrollDataChecklist = ({ updatePayPeriodStatus, jurisdiction, updatePayrollChecklist, payPeriod }) => {
	const [toggle, setToggle] = useState({});

	const [renderChecklist, stepsRequired, stepsCompleted, steps] = useMemo(() => {
		const checklist = Checklist({
			jurisdiction,
			payPeriod,
		});
		let stepsRequired = 0;
		let stepsCompleted = 0;
		let steps = [];
		checklist?.map(({ list }) => {
			list?.map(({ title, progress, target }) => {
				if (target === progress) {
					steps.push(title);
					stepsCompleted++;
				}
				stepsRequired++;
			});
		});
		return [checklist, stepsRequired, stepsCompleted, steps];
	}, [JSON.stringify(payPeriod?.checklist), payPeriod?.id]);

	return (
		<>
			<div
				style={{
					borderRadius: "1rem",
					padding: "2rem",
					border: "1px solid rgb(244,244,244)",
					boxShadow: "1px 1px 5px 0px rgba(0,0,0,0.1)",
					display: "grid",
					gridTemplateColumns: "repeat(3, 1fr)",
					gridGap: "1rem",
				}}
			>
				{renderChecklist?.map(({ title, list }) => {
					return (
						<>
							<div
								style={{
									gridColumn: "span 3",
								}}
							>
								{/* Section Header Ex. The Basics */}
								<h3 style={{ textAlign: "left" }}>{title}</h3>
							</div>
							{list?.map(({ title, tag, list, progress, target, optionals, total }) => {
								const success = progress === target;
								const totalChecked = optionals + progress;
								const toggleKey = toggle[tag];
								const defaultToggle =
									typeof toggleKey === "undefined" ? totalChecked === total : toggleKey;
								return (
									<div
										style={{
											borderRadius: "1rem",
											border: "1px solid rgb(244,244,244)",
											boxShadow: "1px 1px 5px 0px rgba(0,0,0,0.1)",
											height: defaultToggle ? "65.42px" : "auto",
										}}
									>
										<div
											style={{
												borderBottom: "1px solid rgb(244,244,244)",
												padding: "1rem 1rem 1rem 1rem",
												borderRadius: "1rem 1rem 0rem 0rem",
												backgroundColor: success ? "rgb(0, 187, 135)" : "rgb(234,97,28)",
												fontSize: "1.5rem",
												color: "white",
												fontWeight: "bolder",
											}}
										>
											{/* Card Title Ex. Company Details */}
											{title}
											<span style={{ textAlign: "right" }}>
												{success ? (
													<div style={{ float: "right" }}>
														<ChevronDownIcon
															onClick={() => setToggle({ ...toggle, [tag]: !toggleKey })}
															style={{
																height: "1.5em",
																float: "left",
																cursor: "pointer",
																transform: !defaultToggle
																	? "rotate(180deg)"
																	: "rotate(0deg)",
																transition: "transform 0.2s ease-in-out",
																userSelect: "none",
															}}
														/>
													</div>
												) : null}

												<div style={{ float: "right" }}>
													{totalChecked}/{total}
												</div>
												{progress === target && (
													<CheckBadgeIcon
														style={{ height: "2rem", float: "right", color: "white" }}
													/>
												)}
											</span>
										</div>
										{defaultToggle ? null : (
											<div
												style={{
													padding: "1rem 1rem 1rem 1rem",
													height: "calc(100% - 42.42px - 36px)",
												}}
											>
												{list?.map(({ title, value }) => {
													return (
														// Checklist Ex. Company Name
														<Checkbox
															label={title}
															checked={value?.checked}
															action={value?.action}
															disabled={value?.disabled}
															required={value?.required}
															onClick={(tag) => {
																updatePayrollChecklist(tag);
															}}
														/>
													);
												})}
											</div>
										)}
										<div
											style={{
												borderTop: "1px solid rgb(244,244,244)",
												padding: "1rem 0rem 1rem 1rem",
											}}
										>
											{defaultToggle ? null : (
												<ProgressBar
													percentage={(progress / target) * 100}
													style={{ height: "1.5rem", marginRight: "1rem" }}
													color={success ? "rgb(0, 187, 135)" : "rgb(234,97,28)"}
												/>
											)}
										</div>
									</div>
								);
							})}
						</>
					);
				})}
			</div>
			<div className="block-content pr-0">
				<button
					className="btn btn-success pull-right"
					disabled={stepsRequired !== stepsCompleted}
					onClick={() => updatePayPeriodStatus(payPeriod.id, "Data Submitted")}
				>
					{stepsRequired === stepsCompleted ? "Submit Payroll Data" : "Complete All Steps"}
				</button>
				{!payPeriod?.checklist?.["Add Pay Items"] && !payPeriod?.checklist?.["Add Allowance"] ? (
					<Link
						className="btn btn-primary pull-right"
						style={{ marginRight: 10 }}
						to="./data-entry"
					>
						Add {jurisdiction === "MT" ? "Allowances" : "Pay Items"}
					</Link>
				) : null}
			</div>
		</>
	);
};

const Checkbox = ({ checked, action, disabled, label, required, onClick }) => {
	return (
		<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
			<div style={{ float: "left" }}>
				<label
					className={`css-input css-checkbox css-checkbox-${
						checked ? "default" : "primary"
					} remove-margin-t remove-margin-b`}
					style={{
						color: checked ? "rgb(200,200,200)" : undefined,
						textDecoration: checked ? "line-through" : undefined,
					}}
				>
					<input
						type="checkbox"
						checked={checked}
						disabled={disabled}
						onClick={() => {
							onClick && onClick(label);
						}}
					/>
					<span></span>
					{label}
					{required ? (
						<span style={{ color: checked ? "rgb(200,200,200)" : "rgb(234,97,28)" }}>*</span>
					) : null}
					&nbsp;
				</label>
			</div>
			<Link
				to={checked ? undefined : action?.to || "#"}
				target={action?.to?.includes("https://") ? "_blank" : undefined}
				onClick={(e) => {
					if (checked || action?.onClick) {
						e.preventDefault();
						e.stopPropagation();
					}
					if (!checked && action?.onClick) {
						action.onClick();
					}
				}}
				style={{
					color: checked ? "rgb(200,200,200)" : "rgb(234,97,28)",
					textDecoration: checked ? "line-through" : undefined,
					cursor: checked ? "default" : "pointer",
				}}
			>
				{action ? action?.label : null}
				{action?.to?.includes("https://") && (
					<ArrowTopRightOnSquareIcon style={{ height: "1.25rem", marginLeft: "0.5rem" }} />
				)}
			</Link>
		</div>
	);
};

export const Checklist = ({ jurisdiction, payPeriod }) => {
	const { checklist } = payPeriod || {};

	const jurisdictionChecklist = {
		MT: {
			"People": {
				"New Employees": {
					"How to add People": {
						action: {
							to: "https://support.buddy.hr/hc/en-mt/articles/360013334659-Adding-and-Importing-Employees-into-Buddy",
							label: "Read Article",
						},
						checked: checklist?.["How to add People"],
					},
					"Add New Employees": {
						action: {
							to: "/organisation/people",
							label: "Add",
						},
						required: true,
						checked: checklist?.["Add New Employees"],
					},
				},
				"Terminated Employees": {
					"How to remove People": {
						action: {
							to: "https://support.buddy.hr/hc/en-mt/articles/360011707700-Terminating-an-Employee",
							label: "Read Article",
						},
						checked: checklist?.["How to remove People"],
					},
					"Terminate Employees": {
						action: {
							to: "/organisation/people",
							label: "Terminate",
						},
						required: true,
						checked: checklist?.["Terminate Employees"],
					},
				},
				"Salary Changes": {
					"How to add Salary Changes": {
						action: {
							to: "https://support.buddy.hr/hc/en-mt/articles/360012560659-Employee-Salary-Details",
							label: "Read Article",
						},
						"checked": checklist?.["How to add Salary Changes"],
					},
				},
			},
			"Payroll Data": {
				Leave: {
					"How to Add Leave": {
						action: {
							to: "https://support.buddy.hr/hc/en-mt/articles/360021524020-Adding-Timesheet-Entries",
							label: "Read Article",
						},
						checked: checklist?.["How to Add Leave"],
					},
				},
				Timesheets: {
					"How to Add Timesheets": {
						action: {
							to: "https://support.buddy.hr/hc/en-mt/articles/360021524020-Adding-Timesheet-Entries",
							label: "Read Article",
						},
						checked: checklist?.["How to Add Timesheets"],
					},
				},
				Allowances: {
					"How to Add Allowances": {
						action: {
							to: "https://support.buddy.hr/hc/en-mt/articles/360011790840-Adding-a-One-Time-Allowance",
							label: "Read Article",
						},
						checked: checklist?.["How to Add Allowances"],
					},
					"Add Allowance": {
						action: {
							to: "./data-entry",
							label: "Add",
						},
						required: true,
						checked: checklist?.["Add Allowance"],
					},
				},
			},
		},
		UK: {
			"People": {
				"Joiners": {
					"How to add People": {
						action: {
							to: "https://support.buddy.hr/hc/en-gb/articles/360013334659-Adding-Employees-into-Buddy",
							label: "Read Article",
						},
						checked: checklist?.["How to add People"],
					},
					"Add Joiners": {
						action: {
							to: "/organisation/people",
							label: "Add",
						},
						required: true,
						checked: checklist?.["Add Joiners"],
					},
				},
				"Leavers": {
					"How to remove People": {
						action: {
							to: "https://support.buddy.hr/hc/en-gb/articles/360011707700-Terminating-an-Employee",
							label: "Read Article",
						},
						checked: checklist?.["How to remove People"],
					},
					"Terminate Leavers": {
						action: {
							to: "/organisation/people",
							label: "Terminate",
						},
						required: true,
						checked: checklist?.["Terminate Leavers"],
					},
				},
				"Salary Changes": {
					"Add Salary Changes": {
						action: {
							to: "/organisation/people",
							label: "Add",
						},
						required: true,
						checked: checklist?.["Add Salary Changes"],
					},
					"How to add Salary Changes": {
						action: {
							to: "https://support.buddy.hr/hc/en-gb/articles/360012560659-Employee-Salary-Details",
							label: "Read Article",
						},
						checked: checklist?.["How to add Salary Changes"],
					},
				},
			},
			"Payroll Data": {
				"Leave": {
					"How to Add Leave": {
						action: {
							to: "https://support.buddy.hr/hc/en-gb/articles/360010685659-Adding-a-Leave-Application",
							label: "Read Article",
						},
						checked: checklist?.["How to Add Leave"],
					},
				},
				"Timesheets": {
					"How to Add Timesheets": {
						action: {
							to: "https://support.buddy.hr/hc/en-gb/articles/360021524020-Adding-Timesheet-Entries",
							label: "Read Article",
						},
						checked: checklist?.["How to Add Timesheets"],
					},
				},
				"Pay Items": {
					"How to Add Pay Items": {
						action: {
							to: "https://support.buddy.hr/hc/en-mt/articles/360011790840-Adding-a-One-Time-Allowance",
							label: "Read Article",
						},
						checked: checklist?.["How to Add Pay Items"],
					},
					"Add Pay Items": {
						action: {
							to: "./data-entry",
							label: "Add",
						},
						required: true,
						checked: checklist?.["Add Pay Items"],
					},
				},
			},
		},
	};

	const jurisdictionToApply = jurisdictionChecklist[jurisdiction] || {};

	const check = {
		"People": {
			"Salary Changes": {
				"Add Salary Changes": {
					action: {
						to: "/organisation/people",
						label: "Add",
					},
					required: true,
					checked: checklist?.["Add Salary Changes"],
				},
			},
		},
		"Payroll Data": {
			Leave: {
				"Confirm Pending Leave Applications": {
					action: {
						to: "/organisation/leave",
						label: "Confirm",
					},
					required: true,
					checked: checklist?.["Confirm Pending Leave Applications"],
				},
			},
			Timesheets: {
				"Confirm Pending Timesheet Applications": {
					action: {
						to: "/organisation/timesheets",
						label: "Confirm",
					},
					required: true,
					checked: checklist?.["Confirm Pending Timesheet Applications"],
				},
			},
		},
	};

	const mergedChecklist = merge(check, jurisdictionToApply);

	return Object.entries(mergedChecklist || {}).map(([key, value]) => {
		const remappedSubList = Object.entries(value || {})?.map(([key, value]) => {
			const remappedSubSubList = Object.entries(value || {})
				?.map(([key, value]) => {
					return { title: key, value };
				})
				?.sort((a, b) => {
					if (a.value?.required && !b.value?.required) return -1;
					if (!a.value?.required && b.value?.required) return 1;
					if (a.title < b.title) return -1;
					if (a.title > b.title) return 1;
					return 0;
				});

			return {
				title: key,
				tag: camelCase(key),
				list: remappedSubSubList,
				progress: remappedSubSubList?.filter(({ value }) => value?.required && value?.checked).length,
				target: remappedSubSubList?.filter(({ value }) => value?.required).length,
				optionals: remappedSubSubList?.filter(({ value }) => !value?.required && value?.checked)?.length,
				total: remappedSubSubList?.length,
			};
		});
		return { title: key, list: remappedSubList };
	});
};

const mapStateToProps = (state) => {
	return {
		jurisdiction: state.company?.settings?.jurisdiction,
		companyName: state.company?.settings?.name || "Company Name",
		payPeriod: state.payroll?.payPeriodDetails,
	};
};

const mapDispatchToProps = (dispatch) => ({
	updatePayrollChecklist: (toggle) => {
		dispatch(PAYROLL_ACTIONS.updateChecklistToggles(toggle));
		dispatch(PAYROLL_ACTIONS.updatePayrollChecklist());
	},
	updatePayPeriodStatus: (id, status) => dispatch(PAYROLL_ACTIONS.updatePayPeriodStatus(id, status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollDataChecklist);
